import { atom, useAtom } from "jotai";

export const isCloudflareWarningDismissedAtom = atom(false);

export const useIsCloudflareWarningDismissed = () => {
  const [isCloudflareWarningDismissed, setIsCloudflareWarningDismissed] =
    useAtom(isCloudflareWarningDismissedAtom);

  return {
    isCloudflareWarningDismissed,
    setIsCloudflareWarningDismissed,
  };
};
